import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ToastrModule } from 'ngx-toastr';
import { QueryService } from '../services/query.service';
import { ChatService } from '../services/chat.service';
import { PromptBaseComponent } from '../pages/playground/components/prompt/prompt.base.component';



@NgModule({
  declarations: [
    PromptBaseComponent
  ],
  providers: [ QueryService, ChatService],
  imports: [
    CommonModule,
    ToastrModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    FontAwesomeModule
  ],
  exports: [
    PromptBaseComponent
  ]
})
export class SharedModule { }
